import type { Theme } from '@mui/material/styles'

import type { RsvpState } from './rsvp-state'

export type SchedulerColor =
  | 'red'
  | 'pink'
  | 'purple'
  | 'indigo'
  | 'blue'
  | 'teal'
  | 'green'
  | 'lime'
  | 'amber'
  | 'orange'
  | 'grey'

// Prefix used to embed session ID in each calendar event tile's className.
// The click-capture handler in events-calendar.tsx reads it back via classList.
export let SCHEDULER_SESSION_PREFIX = 'scheduler-session-'

export let rsvpSchedulerColor: Partial<Record<RsvpState, SchedulerColor>> = {
  accepted: 'green',
  invited: 'purple',
  waitlisted: 'amber',
  declined: 'red',
  open: 'blue',
  attended: 'grey',
}

export let getRsvpColors = (theme: Theme): Record<RsvpState, string> => ({
  open: theme.palette.info.main,
  invited: theme.palette.analyticsColors.recordedCourses,
  accepted: theme.palette.success.main,
  waitlisted: theme.palette.warning.main,
  declined: theme.palette.error.main,
  attended: theme.palette.success.main,
  past: theme.palette.text.disabled,
})

export let getRsvpLegendItems = (theme: Theme) => {
  let colors = getRsvpColors(theme)
  return [
    { color: colors.accepted, label: 'Registered' },
    { color: colors.invited, label: 'Invited' },
    { color: colors.waitlisted, label: 'Waitlisted' },
    { color: colors.declined, label: 'Declined' },
    { color: colors.open, label: 'Open' },
    { color: colors.attended, label: 'Attended' },
  ]
}

// Short labels for compact contexts (calendar popover chip).
export let rsvpLabelShort: Partial<Record<RsvpState, string>> = {
  open: 'Open',
  invited: 'Invited',
  accepted: 'Registered',
  declined: 'Declined',
  waitlisted: 'Waitlisted',
  attended: 'Attended',
}

// Full labels for row/list contexts (session list rows).
export let rsvpLabelFull: Record<RsvpState, string> = {
  open: 'Registration open',
  invited: 'Invited',
  accepted: 'Registered',
  declined: 'Declined',
  waitlisted: 'Waitlisted',
  attended: 'Attended',
  past: 'Registration closed',
}
